import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button, Hidden } from "@mui/material";

import { ReportDamageImg } from "@/assets/images";
import { Permissions } from "@/shared/domain";
import { isABroker, useAuth, useGlobalFilter, useNavigation } from "@/shared/hooks";

import {
    StyledReportDamage,
    StyledReportDamageContainer,
    StyledReportDamageDescription,
    StyledReportDamageHeader,
    StyledReportDamageImgContainer,
} from "./styled";

const ReportDamagePanel: FC = () => {
    const { t } = useTranslation();
    const { navToReportClaimPage, navToReportSchoolClaimPage } = useNavigation();
    const { user } = useAuth();
    const { policyholdersGF, isProEnvironment } = useGlobalFilter();
    const handleReportDamage = () => {
        navToReportClaimPage();
    };
    const handleReportDamageSchool = () => {
        navToReportSchoolClaimPage();
    };
    return (
        <StyledReportDamage $isDisabled={isABroker()} title={`${isABroker() ? t("Common.PreviewUserNotAllowed") : ""}`}>
            <StyledReportDamageHeader>{t("ReportDamage.Header")}</StyledReportDamageHeader>
            <StyledReportDamageContainer>
                <StyledReportDamageDescription>
                    <p>{t("ReportDamage.Description")}</p>
                    <div>
                        {user.someHasPermission(Permissions.AccessDeclareClaim, policyholdersGF) && (
                            <Button
                                fullWidth
                                className="mt10"
                                disabled={isABroker()}
                                data-testid="report_damage-button-default"
                                onClick={handleReportDamage}
                            >
                                {t("ReportDamage.Button")}
                            </Button>
                        )}
                        {user.someHasPermission(Permissions.CanDeclareSchoolClaim, policyholdersGF) && (
                            <Button
                                fullWidth
                                className="mt10"
                                disabled={isABroker()}
                                data-testid="report_damage-button-school"
                                onClick={handleReportDamageSchool}
                            >
                                {t("ReportDamage.ButtonSchool")}
                            </Button>
                        )}
                    </div>
                </StyledReportDamageDescription>

                {!isProEnvironment && (
                    <Hidden mdDown>
                        <StyledReportDamageImgContainer>
                            <ReportDamageImg />
                        </StyledReportDamageImgContainer>
                    </Hidden>
                )}
            </StyledReportDamageContainer>
        </StyledReportDamage>
    );
};

export default ReportDamagePanel;
